import { Close } from "@mui/icons-material";
import {
  Box,
  Button,
  Container,
  IconButton,
  SwipeableDrawer,
  Typography,
} from "@mui/material";

import logo from "../../Components/images/mainlogo.png";
import { NavLink } from "react-router-dom";

const data = [
  {
    title: "Home",
    path: "/",
  },
  {
    title: "White paper",
    path: "/whitepaper",
  },

  {
    title: "Dapp",
    path: "/staking",
  },
  {
    title: "Farming",
    path: "/farming",
  },
  {
    title: "Contacts Us",
    path: "",
  },
];
const drawerTransitionStyle = {
  transitionDuration: "4000", // Adjust the duration as per your preference
};
const HorizontalNav = ({ toggleDrawer, state }) => {
  const list = () => (
    <Box
      sx={{
        width: "100vw",
        height: "100vh",
        py: 2,
        background:
          " linear-gradient(98.3deg, rgb(0, 0, 0) 10.6%, rgb(255, 0, 0) 97.7%)",
      }}
      onClick={() => toggleDrawer(false)}
      onKeyDown={() => toggleDrawer(false)}
    >
      <Container maxWidth="xl">
        <Box display="flex" justifyContent={"space-between"}>
          <Box component={"img"} src={logo} width="100px" ml={-2} alt="logo" />
          <Box>
            <Button
              sx={{
                color: "white",
                backgroundColor: "#C63635",
                border: "2px solid #fff",
                borderRadius: "25px",
                padding: "0.5rem 1.5rem",
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "#C63635",
                },
              }}
            >
              About Us
            </Button>
          </Box>
        </Box>
        <Box
          display={"flex"}
          justifyContent={"left"}
          alignItems={"center"}
          height={"67vh"}
          gap={{ xl: 10, lg: 8, md: 5, xs: 2 }}
        >
          <Box textAlign={"center"} mt={2} mr={{ lg: 10, md: 8, xs: 4 }}>
            <IconButton>
              <Close sx={{ fontSize: "3rem" }} />
            </IconButton>
          </Box>
          {data.map((item, i) => (
            <NavLink
              to={i === 4 ? "" : item?.path}
              onClick={() => {
                if (i === 4) {
                  window.location.href =
                    "mailto:cryptogainerr007@gmail.com?subject=Contact%20Us&body=Please%20send%20us%20your%20message.";
                }
              }}
              style={{ textDecoration: "none", color: "white" }}
              key={i}
            >
              <Typography
                className="rainfall-button"
                sx={{
                  cursor: "pointer",
                  mt: 2,
                  textAlign: "left",
                  fontFamily: "Roboto Slab",
                  fontSize: "25px",
                  transition: "1s ease-in-out",
                  color: "#fff",
                  "&:hover": {
                    transition: "1s ease-in-out",
                    color: "#E0115F",
                  },
                }}
              >
                {item?.title}
              </Typography>
            </NavLink>
          ))}
        </Box>
        <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
          <Box
            sx={{
              cursor: "pointer",
              width: "80px",
              height: "80px",
              borderRadius: "50%",
              fontWeight: "400",
              color: "#fff",
              border: "2px solid white",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              lineHeight: "18px",
              transition: "1s ease-in-out",
              "&:hover": {
                backgroundColor: "#fff",
                color: "#E0115F",
                transition: "1s ease-in-out",
              },
            }}
          >
            <Box>
              <Typography
                sx={{
                  fontSize: "12px",
                  fontFamily: "Lato",
                  textAlign: "center",
                  textTransform: "uppercase",
                }}
              >
                White
              </Typography>
              <Typography
                sx={{
                  fontSize: "16px",
                  fontFamily: "Lato",
                  mt: -0.5,
                  textAlign: "center",
                  textTransform: "uppercase",
                }}
              >
                Paper
              </Typography>
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
  return (
    <Box>
      <SwipeableDrawer
        anchor={"left"}
        open={state}
        onClose={() => toggleDrawer(false)}
        onOpen={() => toggleDrawer(true)}
        PaperProps={{
          style: drawerTransitionStyle, // Apply the custom inline style
        }}
      >
        {list()}
      </SwipeableDrawer>
    </Box>
  );
};

export default HorizontalNav;
